module.exports = __webpack_public_path__ + "static/img/akum_800_460.2bec7b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_460.svg
// module id = yeP5
// module chunks = 1